export default function(num) {
  if (String(num).length === 1) {
    return `0${num}`;
  } else {
    return num;
  }
}
